import React from 'react';
import { Paper, Title, Text, Avatar, Stack, Badge } from '@mantine/core';

/**
 * AccountInfoPanel Component
 * Displays user account information
 */
const AccountInfoPanel = ({ user }) => {
  if (!user) return null;

  // Get initials for avatar
  const getInitials = (email) => {
    if (!email) return '?';
    return email.charAt(0).toUpperCase();
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <Paper
      radius="md"
      p="xl"
      withBorder
      style={{
        borderTop: '4px solid var(--primary-gold)'
      }}
    >
      <Title order={3} size="h4" mb="lg" style={{ color: 'var(--charcoal)' }}>
        Account Information
      </Title>

      {/* Avatar and Name - Center Aligned */}
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <Avatar
          size={80}
          radius="50%"
          style={{
            background: 'linear-gradient(135deg, var(--primary-gold), var(--deep-gold))',
            color: 'white',
            fontSize: '2rem',
            fontWeight: 700,
            margin: '0 auto 1rem'
          }}
        >
          {getInitials(user.email)}
        </Avatar>

        <Text size="lg" weight={700} mb="xs">
          {user.user_metadata?.full_name || user.email}
        </Text>
        <Text size="sm" color="dimmed">
          {user.email}
        </Text>
      </div>

      {/* Details - Left Aligned */}
      <Stack spacing="md">
        <div>
          <Text size="xs" weight={600} color="dimmed" mb={4}>MEMBER SINCE</Text>
          <Text size="sm" weight={600}>
            {formatDate(user.created_at)}
          </Text>
        </div>

        <div>
          <Text size="xs" weight={600} color="dimmed" mb={6}>ACCOUNT STATUS</Text>
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Badge color="green" variant="light">Active</Badge>
          </div>
        </div>

        <div>
          <Text size="xs" weight={600} color="dimmed" mb={6}>EMAIL VERIFIED</Text>
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Badge color={user.email_confirmed_at ? 'green' : 'yellow'} variant="light">
              {user.email_confirmed_at ? 'Verified' : 'Pending'}
            </Badge>
          </div>
        </div>
      </Stack>
    </Paper>
  );
};

export default AccountInfoPanel;
